




import Chart from "chart.js";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ChartOptions, DataSet } from "./graphData";

@Component
export default class BarChart extends Vue {
  @Prop({ default: [] }) public readonly labels!: Array<string>;
  // @Prop({ default: [] }) public readonly colors!: Array<string>;
  @Prop({ default: [] }) public readonly data!: Array<DataSet>;

  @Prop({ default: () => new ChartOptions() })
  public readonly options!: ChartOptions;

  public chart: any;

  @Watch("labels", { immediate: false })
  public onPropertyChangedLabel(value: any, oldValue: any) {
    if (null !== this.labels && this.labels.length > 0) {
      this.makeChart();
    }
  }

  @Watch("data", { immediate: false })
  public onPropertyChangedDataset(value: any, oldValue: any) {
    if (null !== this.data && this.data.length > 0) {
      this.makeChart();
    }
  }

  public mounted() {
    if (null !== this.labels && this.labels.length > 0) {
      this.makeChart();
    }
  }

  public makeChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    this.createChart({ datasets: this.data, labels: this.labels });
  }

  public createChart(chartData: object) {
    const canvas = document.getElementById("bars") as HTMLCanvasElement;
    const options = {
      type: "bar",
      data: chartData,
      options: this.options,
    };
    this.chart = new Chart(canvas, options);
  }
}
